import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect, useRef, useState } from 'react';
import useNavState from '../../../hooks/useNavState';
import { usePostRewardCenterMutation } from '../../../state/query/rewardCenter';
import { usePostOTPSendEmailMutation } from '../../../state/query/oneTimePassword';
import QueryParamsProxy from '../../../utils/queryParamProxy';
import screens from '../../index';
import { FILTER_TYPES } from '../../../utils/filterData';
import useFilterData from '../../../hooks/useFilterData';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { ServerResponseKeys } from '../../../api/Constants';
import routeParamConstants from '../../../utils/routeParamConstants';
import QueryParamProxy from '../../../utils/queryParamProxy';
import { REQUEST_STATE } from '../../OneTimePassword/hooks/useOTPrequestHandler';
import { REWARD_CENTER_TABS } from '../constants';
import { setRewardCenterNotification } from '../../../state/actions/rewardCenter';
var rewardCenterFeatureDefault = {
  profile: {},
  offers: [],
  categories: []
};

var useRewardCenter = function useRewardCenter(_ref) {
  var navigation = _ref.navigation;
  useNavState();
  var dispatch = useDispatch();
  var paramsRewardCenterTab = QueryParamProxy.findParam(routeParamConstants.PARAM_RC_TAB, null);

  var _usePostRewardCenterM = usePostRewardCenterMutation(),
      _usePostRewardCenterM2 = _slicedToArray(_usePostRewardCenterM, 2),
      postRewardCenter = _usePostRewardCenterM2[0],
      _usePostRewardCenterM3 = _usePostRewardCenterM2[1],
      rewardCenterFeatureState = _usePostRewardCenterM3.data,
      isLoading = _usePostRewardCenterM3.isLoading;

  var _usePostOTPSendEmailM = usePostOTPSendEmailMutation(),
      _usePostOTPSendEmailM2 = _slicedToArray(_usePostOTPSendEmailM, 1),
      postOTPSendEmail = _usePostOTPSendEmailM2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showProfile = _useState2[0],
      setShowProfile = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showCategories = _useState4[0],
      setShowCategories = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedOffer = _useState6[0],
      setSelectedOffer = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      categorySelected = _useState8[0],
      setCategorySelected = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      purchaseResponse = _useState10[0],
      setPurchaseResponse = _useState10[1];

  var _useSelector = useSelector(function (state) {
    return {
      RewardsImageBaseURL: state.app.assetsUrls.RewardsImageBaseURL,
      isAccountLinked: state.playerInfo.isAccountLinked,
      rewardCenterAssets: state.assetsPackage.assets.REWARD_CENTER_FEATURE
    };
  }, shallowEqual),
      RewardsImageBaseURL = _useSelector.RewardsImageBaseURL,
      isAccountLinked = _useSelector.isAccountLinked,
      rewardCenterAssets = _useSelector.rewardCenterAssets;

  var isFirstRender = useRef(true);
  var fetchRewardCenter = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return postRewardCenter({
              requestAssetsData: false
            });

          case 3:
            _context.next = 8;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            QueryParamsProxy.navigate(navigation, screens.Home);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  })), [navigation, postRewardCenter]);
  var handleOTPSendEmailRequest = useCallback(function () {
    postOTPSendEmail().unwrap().then( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var _QueryParamProxy$setQ;

        var otpAuthTransaction, otpPromise, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                otpAuthTransaction = _ref3[ServerResponseKeys.CALL_RESPONSE].otpAuthTransaction;
                otpPromise = QueryParamProxy.setQueryParamsWithModalPromise((_QueryParamProxy$setQ = {}, _defineProperty(_QueryParamProxy$setQ, routeParamConstants.PARAM_MODAL, screens.OneTimePassword), _defineProperty(_QueryParamProxy$setQ, routeParamConstants.PARAM_OTP_TRANSACTION_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.transactionId), _defineProperty(_QueryParamProxy$setQ, routeParamConstants.PARAM_OTP_USER_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.userId), _QueryParamProxy$setQ));
                _context2.next = 4;
                return otpPromise;

              case 4:
                response = _context2.sent;
                if ((response === null || response === void 0 ? void 0 : response.success) === REQUEST_STATE.AUTHENTICATE) fetchRewardCenter();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }()).catch(function () {
      return null;
    });
  }, [postOTPSendEmail, fetchRewardCenter]);
  useEffect(function () {
    fetchRewardCenter(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchRewardCenter, isAccountLinked, purchaseResponse]);
  useEffect(function () {
    if (!isFirstRender.current && isAccountLinked === 'yes') {
      setShowProfile(true);
    }

    isFirstRender.current = false;
  }, [isAccountLinked]);
  useEffect(function () {
    (rewardCenterFeatureState === null || rewardCenterFeatureState === void 0 ? void 0 : rewardCenterFeatureState.otpExpired) && handleOTPSendEmailRequest();
  }, [rewardCenterFeatureState, handleOTPSendEmailRequest]);
  useEffect(function () {
    paramsRewardCenterTab === REWARD_CENTER_TABS.PROFILE && setShowProfile(true);
    return function () {
      var _QueryParamProxy$setQ2;

      QueryParamProxy.setQueryParams((_QueryParamProxy$setQ2 = {}, _defineProperty(_QueryParamProxy$setQ2, routeParamConstants.PARAM_RC_TAB, undefined), _defineProperty(_QueryParamProxy$setQ2, routeParamConstants.PARAM_SKIP_SET_MODAL, true), _QueryParamProxy$setQ2));
    };
  }, [paramsRewardCenterTab]);
  useEffect(function () {
    QueryParamProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, undefined));
    return function () {
      dispatch(setRewardCenterNotification(null));
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      filterData = _useState12[0],
      setFilterData = _useState12[1];

  var _useFilterData = useFilterData(rewardCenterFeatureState === null || rewardCenterFeatureState === void 0 ? void 0 : rewardCenterFeatureState.offers, filterData, FILTER_TYPES.REWARD_CENTER_FILTER),
      filteredValue = _useFilterData.filteredValue;

  var clearFilterData = function clearFilterData() {
    setCategorySelected(null);
    setFilterData(null);
    setShowCategories(true);
  };

  return _objectSpread(_objectSpread({
    rewardCenterAssets: rewardCenterAssets
  }, rewardCenterFeatureState !== null && rewardCenterFeatureState !== void 0 ? rewardCenterFeatureState : rewardCenterFeatureDefault), {}, {
    showProfile: showProfile,
    setShowProfile: setShowProfile,
    showCategories: showCategories,
    setShowCategories: setShowCategories,
    setFilterData: setFilterData,
    selectedOffer: selectedOffer,
    setSelectedOffer: setSelectedOffer,
    categorySelected: categorySelected,
    setCategorySelected: setCategorySelected,
    RewardsImageBaseURL: RewardsImageBaseURL,
    offers: filteredValue,
    isInitRewardsLoading: isLoading,
    clearFilterData: clearFilterData,
    purchaseResponse: purchaseResponse,
    setPurchaseResponse: setPurchaseResponse
  });
};

export default useRewardCenter;